import { render, staticRenderFns } from "./create-non-personal.vue?vue&type=template&id=5b1bd6ba&scoped=true&"
import script from "./create-non-personal.vue?vue&type=script&lang=js&"
export * from "./create-non-personal.vue?vue&type=script&lang=js&"
import style0 from "./create-non-personal.vue?vue&type=style&index=0&id=5b1bd6ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1bd6ba",
  null
  
)

export default component.exports